<template>
    <LayoutWrapper>
        <TopBar /> 
        <div class="p-grid p-jc-center p-mt-6">
            <div class="p-lg-6 p-sm-12">
                <form @submit="onSubmit">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-12">
                            <BlockUI :blocked="blocked">
                                <Card class="card">
                                    <template #content>
                                        <div class="p-grid p-jc-center">
                                            <h4 class="p-text-center p-text-bold">Retrieve your Student Information</h4>
                                        </div>
                                        <hr />
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 p-md-6">
                                                <label class="p-text-uppercase">Learner Reference Number</label>
                                                <InputText type="text" v-model="lrn" :class="{'p-invalid': lrnError}" />
                                                <small class="p-error" v-if="lrnError">Please enter your Learner Reference Number</small>                                    
                                            </div>
                                            <div class="p-field p-col-12 p-md-6">
                                                <label class="p-text-uppercase">Date of birth</label>
                                                <InputText type="date" v-model="birthday" :class="{'p-invalid': birthdayError}" />
                                                <small class="p-error" v-if="birthdayError">Please enter your date of birth</small>                                    
                                            </div>                                
                                        </div>
                                        <div v-if="notFound" class="alert">
                                            <div style="font-weight: 500;">Note:</div>
                                            <div>The system is currently undergoing maintenance and upgrades in preparation for the incoming academic year. If you have entered the required information and receive a 'No Record Found' message, please proceed clicking the button below.</div>
                                            <div style="text-align: center; padding-top: 15px;">
                                                <Button label="Proceed as New Student" class="p-button-danger" @click="newStudent"/>
                                            </div>
                                        </div>
                                    </template>
                                    <template #footer>
                                        <hr />
                                        <div class="lzds-center p-mt-1 p-mb-4">
                                            <Button icon="pi pi-times" label="Back" class="p-button-secondary" @click="back"/>
                                            <NextButton :loading="loading" style="margin-left: .5em" />
                                        </div>
                                    </template>                        
                                </Card>
                            </BlockUI>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <Footer />
    </LayoutWrapper>
</template>

<script>

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { useToast } from "primevue/usetoast"
import { ref, watch } from 'vue'

import LayoutWrapper from '../components/LayoutWrapper'
import Footer from '../components/Footer'
import TopBar from '../components/TopBar'
import NextButton from '../components/NextButton'

import Card from 'primevue/card/sfc'
import Button from 'primevue/button/sfc'
import RadioButton from 'primevue/radiobutton/sfc'
import InputText from 'primevue/inputtext/sfc'
import Dropdown from 'primevue/dropdown/sfc'
import BlockUI from 'primevue/blockui/sfc'

import { useForm, useField } from 'vee-validate'

export default {
    components: {
        LayoutWrapper,
        Footer,
        TopBar,
        Card,
        Button,
        RadioButton,
        InputText,
        Dropdown,
        NextButton,
        BlockUI  
    },
    setup() {

        const store = useStore()
        const router = useRouter()
        const route = useRoute()
        const toast = useToast()

        const studentStatus = 'Regular'

        store.dispatch('selections/INIT')
        store.dispatch('students/INIT')    

        watch(
            () => store.state.students.student.id,
            (data, prevData) => {
                router.push('/student/info')
            }
        )

        watch(
            () => store.state.students.notFound,
            (data, prevData) => {
                console.log(data)
            }
        )

        const init = {
            initialValues: {
                lrn: null,
                birthday: null,
                // lrn: '101070110017',
                // birthday: '2006-10-19',                
            }
        }        

        const { setValues, handleSubmit, resetForm } = useForm(init);
        
        function validateField(value) {
            if (!value) {
                return "This field is required";
            }
            return true;
        }

        const { value: lrn, errorMessage: lrnError } = useField('lrn',validateField);    
        const { value: birthday, errorMessage: birthdayError } = useField('birthday',validateField);    
        
        const onSubmit = handleSubmit((values, actions) => {
            const { lrn, birthday } = values
            store.dispatch('students/QUERY_STUDENT', { lrn, birthday })
        })

        const back = () => {
            router.push('/')
        }

        const newStudent = () => {
            router.push('/profile/new')
            store.dispatch('students/PRIVACY')
        }

        return {
            lrn,
            lrnError,
            birthday,
            birthdayError,
            back,
            newStudent,
            onSubmit,
        }

    },
    computed: {
        loading() {
            return this.$store.state.students.loading
        },
        blocked() {
            return this.$store.state.students.loading
        },
        notFound() {
            return this.$store.state.students.notFound===true
        }
    }
}
</script>

<style scoped>

    .card {
        border-top: 4px solid #252a83;
    }

    .lzds-width {
        width: 80%;
    }

    @media only screen and (max-width: 1200px) {
        .lzds-width {
            width: 80%
        }
    }

    @media only screen and (max-width: 1024px) {
        .lzds-width {
            width: 80%
        }
    }

    @media only screen and (max-width: 768px) {
        .lzds-width {
            width: 100%
        }
    }

    @media only screen and (max-width: 480px) {
        .lzds-width {
            width: 100%
        }      
    }

    @media only screen and (max-width: 360) {
        .lzds-width {
            width: 100%
        }      
    }

    @media only screen and (max-width: 320) {
        .lzds-width {
            width: 100%
        }    
    }

    /* The alert message box */
    .alert {
        padding: 20px;
        border: 1px solid;
        border-radius: 3px;
        border-color: #ff625a;
        background-color: #f4d0ce; /* Red */
        color: rgb(221, 11, 11);
        margin-bottom: 15px;
    }

</style>